/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { QuestionnaireFormElement } from '../../questionnaireTemplate.types';
import { questionElementSchema } from './formValidation.schema';

export interface FieldValidationError {
  message: string;
  path: (string | number)[];
  type: string;
  context: Record<string, any>;
  questionId: string;
}

/**
 * Immutably applies a dot-path value to an object clone.
 * e.g. deepApply(obj, 'options.0.text', 'hello')
 */
function deepApply(obj: any, path: string, value: any): any {
  const parts = path.split('.');
  const result = { ...obj };
  let cursor = result;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i];
    const nextKey = parts[i + 1];
    // eslint-disable-next-line no-restricted-globals
    const isNextIndex = !isNaN(Number(nextKey));

    cursor[key] = isNextIndex ? [...(cursor[key] ?? [])] : { ...(cursor[key] ?? {}) };
    cursor = cursor[key];
  }

  cursor[parts[parts.length - 1]] = value;
  return result;
}

/**
 * Validates a single field update on a form element.
 * Returns a shaped error matching backend format, or null if valid.
 */
export function validateElementField(
  element: QuestionnaireFormElement,
  updatedPath: string,
  newValue: any,
): FieldValidationError | null {
  const cloned = deepApply({ ...element }, updatedPath, newValue);

  const { error } = questionElementSchema.validate(cloned, {
    abortEarly: false,
    allowUnknown: true,
  });

  if (!error) return null;

  const match = error.details.find((d) => d.path.join('.') === updatedPath);
  if (!match) return null;

  return {
    message: match.message,
    path: ['questions', match.path[0] ?? /* istanbul ignore next */ updatedPath, ...match.path.slice(1)],
    type: match.type,
    context: {
      ...match.context,
      label: `questions.${updatedPath}`,
    },
    questionId: element.id,
  };
}
